var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchServices = function SvgSearchServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DAD6CD",
    d: "M103.075 13.652v100.525c0 4.427-3.745 8.02-8.36 8.02h-74.58a8.6 8.6 0 0 1-2.106-.262c-3.6-.898-6.253-4.026-6.253-7.758V13.652c0-4.432 3.745-8.02 8.36-8.02h74.58c4.614 0 8.359 3.588 8.359 8.02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4553A9",
    d: "M44.607 36.864H16.56c-7.732 0-14 6.268-14 14v12.091c0 7.732 6.268 14 14 14h28.047z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFECB1",
    d: "M23.352 62.298c4.696 0 8.503-3.63 8.503-8.109 0-4.478-3.807-8.109-8.503-8.109-4.697 0-8.504 3.63-8.504 8.11 0 4.478 3.807 8.108 8.504 8.108M7.68 77.498c0-8.313 7.066-15.053 15.785-15.053 8.718 0 15.784 6.738 15.784 15.053"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E398E",
    d: "M86.653 36.864H44.607v40.633h42.046z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA5B",
    d: "M65.477 61.805c4.723 0 8.551-3.7 8.551-8.263 0-4.564-3.828-8.264-8.55-8.264s-8.552 3.7-8.552 8.264 3.829 8.263 8.551 8.263M49.753 77.497c0-8.471 7.105-15.339 15.872-15.339s15.872 6.868 15.872 15.34"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    d: "M114.7 36.864H86.653v40.633H114.7c7.732 0 14-6.268 14-14V50.864c0-7.732-6.268-14-14-14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD00",
    d: "M107.755 61.617c4.815 0 8.718-3.772 8.718-8.425s-3.903-8.426-8.718-8.426c-4.816 0-8.72 3.772-8.72 8.426 0 4.653 3.904 8.425 8.72 8.425M91.492 77.497c0-8.637 7.246-15.64 16.184-15.64s16.184 7.003 16.184 15.64"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#7886D9",
    d: "M18.638 108.466 28.233 93.2c1.064-1.692 3.33-2.253 5.06-1.252a3.463 3.463 0 0 1 1.207 4.878l-9.595 15.265c-1.064 1.693-3.33 2.254-5.06 1.253a3.463 3.463 0 0 1-1.207-4.878"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD008",
    d: "M41.885 96.99c-12.583 0-22.784-9.971-22.784-22.272s10.2-22.272 22.784-22.272 22.784 9.972 22.784 22.272-10.2 22.272-22.784 22.272"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA5B",
    d: "M41.885 96.99c-12.583 0-22.784-9.971-22.784-22.272s10.2-22.272 22.784-22.272z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#7789EF",
    d: "M42.448 89.084h-.464V60.416h.464c8.22 0 14.896 6.425 14.896 14.336s-6.676 14.336-14.896 14.336z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1BDFF",
    d: "M41.52 89.084h.464V60.416h-.464c-8.22 0-14.896 6.425-14.896 14.336S33.3 89.088 41.52 89.088z"
  })));
};
export { SvgSearchServices as Icon };
export default __webpack_public_path__ + "static/media/b635041b9664882f425d4245b231dd72.svg";